function ItemSlider(el) {
    this.el = el;
    this.slider = null;
    this.controls = this.el.querySelector('.jsItemSliderControls');
    this.indicator = this.controls.querySelector('.jsItemSliderControlsIndicator');
    this.slides = this.el.querySelector('.jsItemSliderSlides');
    this.slideCount = this.slides.querySelectorAll('.slide').length;

    this.initSlider();
    this.initControls();
}

ItemSlider.prototype.initSlider = function() {
    this.slider = new Flickity(this.slides, {
        imagesLoaded: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true
    });
};

ItemSlider.prototype.initControls = function() {
    this.controls.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'button') {
            e.preventDefault();

            if (e.target.classList.contains('prev')) this.slider.previous();
            else this.slider.next();
        }
    });

    this.indicator.innerHTML = '1/' + this.slideCount;
    this.slider.on('change', index => this.indicator.innerHTML = (index + 1) + '/' + this.slideCount);
};

(function() {
    const itemSliders = document.querySelectorAll('.jsItemSlider') || [];
    for (let i = 0; i < itemSliders.length; i++) new ItemSlider(itemSliders[i]);
})();
